import React from "react";
import { SPLASH_LAYOUTS } from "./index";

export function SplashScreenRouter({ config }) { 
  if (!config) {
    console.warn('No splash config provided');
    return null;
  }

  const SplashComponent = SPLASH_LAYOUTS[config.layout] || SPLASH_LAYOUTS.default;

  if (!SplashComponent) {
    console.warn(`No splash layout found for: ${config?.layout}`);
    return null;
  }

  return <SplashComponent config={config} />;
}